import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { EnvironmentChip } from './EnvironmentChip';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function format(date: Date) {
  const time = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  const label = `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
  return { time, label };
}

/** Live wall-clock chip — the only piece of the topbar with no backend round-trip, since it's purely local time. */
export function ClockChip() {
  const [now, setNow] = useState(() => format(new Date()));

  useEffect(() => {
    const id = setInterval(() => setNow(format(new Date())), 15_000);
    return () => clearInterval(id);
  }, []);

  return <EnvironmentChip icon={<Clock size={16} />} value={now.time} label={now.label} />;
}
